"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _async = require("react-select/async");

var _async2 = _interopRequireDefault(_async);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = ({
  answer,
  onChange,
  autocompleteRequest,
  placeholder,
  requestUrl
}) => _react2.default.createElement(_async2.default, {
  placeholder: answer || placeholder,
  className: "material-survey-selection",
  styles: {
    menu: provided => ({ ...provided,
      fontFamily: "Roboto, sans-serif"
    }),
    container: provided => ({ ...provided,
      fontFamily: "Roboto, sans-serif"
    }),
    menuPortal: provided => ({ ...provided,
      zIndex: 10000
    })
  },
  loadOptions: async inputValue => {
    if (autocompleteRequest) {
      return (await autocompleteRequest(requestUrl, inputValue)).map(({
        value,
        label,
        subLabel
      }) => ({
        value,
        label: subLabel ? _react2.default.createElement("div", {
          "aria-label": label
        }, label, _react2.default.createElement("div", {
          style: {
            opacity: 0.7,
            fontSize: 12
          },
          "aria-label": subLabel
        }, subLabel)) : label
      }));
    } else {
      return [{
        value: "",
        label: "No autocompleteRequest callback configured"
      }];
    }
  },
  menuPortalTarget: document.body,
  onChange: ({
    value
  }) => onChange(value)
});